<template>
    <div class="header">
        <div class="tabBox">
            <div class="topImg"><img src="../assets/img/topLogo@2x.png" alt=""></div>
         
           
        </div>
    </div>

</template>
<script>
export default {
    props: {
        msg: String
    },
    data() {
        return {
            activeIndex: '1',
            tel: "400-1535-345",
        };
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.el-menu-demo {
    border: none !important;

    .el-menu-item {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 1rem;
        color: #2E3640 !important;
        line-height: 4.125rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding: 0 2.0625rem !important;

        a {
            text-decoration: none !important;
        }
    }

    .is-active {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 1rem;
        color: #009B75 !important;
        line-height: 4.125rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
        border-bottom: .125rem solid #009B75 !important;
    }
}

.header {
    width: 120rem;
    margin: 0 auto;

    .tabBox {
        display: flex;

        height: 6.25rem;
        padding-top: .9375rem;
        margin: 0 auto;

        .topImg {
            z-index: 9999;

            img {
                width: 27.5rem;
                height: 4.25rem;
                padding-left: 8.625rem;
                padding-right: 12rem;
                background: #fff;
            }


        }
    }
}

.phoneBox {
    margin-left: 1.875rem;
    padding-left: 3.125rem;
    height: 4.25rem;
    display: grid;
    place-items: center;
    justify-items: end;
    border-left: .0625rem solid #DFE3E8;

    .phoneImgBox {
        display: flex;
        align-items: center;

        img {
            width: 1.125rem;
            height: 1.125rem;
            margin-right: .625rem;
        }

        .phoneText {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .75rem;
            color: #353535;
            line-height: 2rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
            opacity: .5;
        }
    }


    .phoneNumber {
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 1.125rem;
        color: #000000;
        line-height: 2rem;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }
}
</style>